module.exports = __webpack_public_path__ + "0b7813f14c8b517ffe8b4da753f42807.png";